import React from 'react';
import { SimpleGrid, Switch } from '@mantine/core';

/** Interrupteurs lecture (fichier + embed) — grille 2×2 pour sidebar Puck étroite. */
export function MediaPlaybackFields({ playback = {}, onPatch }) {
  const pb = playback || {};

  const update = (patch) => onPatch({ ...pb, ...patch });

  return (
    <SimpleGrid cols={2} spacing="xs" verticalSpacing={8}>
      <Switch
        size="xs"
        label="Contrôles"
        checked={pb.controls !== false}
        onChange={(e) => update({ controls: e.currentTarget.checked })}
        styles={{ label: { fontSize: 12, whiteSpace: 'nowrap' } }}
      />
      <Switch
        size="xs"
        label="Lecture auto"
        checked={!!pb.autoplay}
        onChange={(e) => update({
          autoplay: e.currentTarget.checked,
          muted: e.currentTarget.checked ? true : pb.muted,
        })}
        styles={{ label: { fontSize: 12, whiteSpace: 'nowrap' } }}
      />
      <Switch
        size="xs"
        label="Boucle"
        checked={!!pb.loop}
        onChange={(e) => update({ loop: e.currentTarget.checked })}
        styles={{ label: { fontSize: 12, whiteSpace: 'nowrap' } }}
      />
      <Switch
        size="xs"
        label="Muet"
        checked={!!pb.muted}
        onChange={(e) => update({ muted: e.currentTarget.checked })}
        styles={{ label: { fontSize: 12, whiteSpace: 'nowrap' } }}
      />
    </SimpleGrid>
  );
}
